export default "__VITE_ASSET__4c45db9b__"